import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  add_user,
  delete_user,
  get_user,
  get_user_list,
  update_user,
  get_permission_user_list,
} from "../Service/ApiServices";
import { toast } from "react-toastify";

const initialState = {
  data: [],
  permissionuserlist:[],
  datalist: [],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name : "",
    fav_image : "",
    background_image : "",
    logo : "",
    address : "",
    school_code : "",
    title : "",
    description : "",
    username:"",
    password:""
  },
};
// Async Thunks for API Calls
export const fetchDataList = createAsyncThunk(
  'user/fetchDataList',
  async ({token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_user_list(token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const fetchPermUserList = createAsyncThunk(
  'user/fetchPermUserList',
  async ({token, signal,school_id,role }, { rejectWithValue }) => {
    try {
      const response = await get_permission_user_list(token, signal,school_id,role);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Async Thunks for API Calls
export const fetchData = createAsyncThunk(
  "user/fetchData",
  async ({ page, page_size, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_user(page, page_size, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const createData = createAsyncThunk(
  "user/createData",
  async ({ data,role, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_user(data,role, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateData = createAsyncThunk(
  "user/updateData",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_user(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteData = createAsyncThunk(
  "user/deleteData",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_user({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, school_class, name, nick_name } = action.payload;
      state.formData = { id, school_class, name, nick_name };
    },
    resetFormData(state) {
      state.formData = {
        name : "",
        fav_image : "",
        background_image : "",
        logo : "",
        address : "",
        school_code : "",
        title : "",
        description : "",
        username:"",
        password:""
      };
    },
    setData(state, action) {
      state.data = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchPermUserList.fulfilled, (state, action) => {
      state.permissionuserlist=action.payload
    })
    .addCase(fetchPermUserList.rejected, (state, action) => {
      state.permissionuserlist=[]
    })
    // User list 
    .addCase(fetchDataList.fulfilled, (state, action) => {
      state.datalist = action.payload.data;
    })
      // Fetch Classes
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createData.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createData.fulfilled, (state, action) => {
        state.addLoading = false;
        state.data = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createData.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updateData.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateData.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateData.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;
        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deleteData.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteData.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteData.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setData,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize
} = userSlice.actions;
export default userSlice.reducer;
